(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-custom"] && !Shopify.designMode) return;
  try {
    (function() {
    const purposeSelect = document.getElementById('ContactForm-purpose');
    const newEmailField = document.getElementById('ContactForm-new-email-field');
    const oldEmailField = document.getElementById('ContactForm-old-email-field');
    const deleteField = document.getElementById('ContactForm-delete-fields');
    const newEmailInput = document.getElementById('ContactForm-new-email');
    const oldEmailInput = document.getElementById('ContactForm-old-email');
    const deleteEmailInput = document.getElementById('ContactForm-delete-email');

    if (!purposeSelect) return;

    function hideField(field, input) {
      field.hidden = true;
      input.disabled = true;
      input.removeAttribute('required');
      input.value = '';
    }

    function showField(field, input, required) {
      field.hidden = false;
      input.disabled = false;
      if (required) input.setAttribute('required', '');
    }

    purposeSelect.addEventListener('change', function() {
      const value = this.value;

      hideField(newEmailField, newEmailInput);
      hideField(oldEmailField, oldEmailInput);
      hideField(deleteField, deleteEmailInput);

      if (value === 'メールアドレスの変更') {
        showField(newEmailField, newEmailInput, true);
        showField(oldEmailField, oldEmailInput, false);
      } else if (value === 'アカウントの削除') {
        showField(deleteField, deleteEmailInput, true);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
